<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">Academic Records</h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-4">
                            <div class="col-xxl-4 col-sm-6">
                                <CommonFslcCard :item="employee.fslc_certificate || {}" />
                            </div>
                            <div v-for="(education, eduIndex) in educations" :key="eduIndex"
                                class="col-xxl-4 col-sm-6">
                                <CommonEducationCard :item="education" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    props: {
        employee: {
            type: Object,
            required: true
        }
    },
    computed: {
        user() {
            return this.employee.user
        },
        educations(){
            return this.employee.educations
        }
    }
}
</script>

<style></style>